skrilla.controller('maximumEntriesPerUserCalculatorCtrl', function ($scope, cacheService) {
    $scope.data = cacheService.getObject("maximumEntries");

    console.log($scope.data);

    if($scope.data.maximumEntriesPerUser) {
        $scope.maximumEntriesPerUserNumber = $scope.data.maximumEntriesPerUser;
    }
    else{
        $scope.maximumEntriesPerUserNumber = 150;
        $scope.maximumEntriesPerUserPercent = 3;
    }
    $scope.calculate = function(){

    }
    $scope.getMaximumRostersPerUser = function(){
        const percentToNumber = Math.floor(($scope.data.maximumEntries / 100) * $scope.maximumEntriesPerUserPercent);
        console.log(percentToNumber)
        $scope.data.maximumEntriesPerUser = percentToNumber;
        cacheService.registerObject("maximumEntries", $scope.data);
        return percentToNumber;
    }

});